import type { LogLevel } from "./types";

const ORDER: Record<LogLevel, number> = {
  TRACE: 0,
  DEBUG: 1,
  INFO: 2,
  WARN: 3,
  ERROR: 4,
  FATAL: 5,
};

export function levelRank(level: LogLevel): number {
  return ORDER[level] ?? 0;
}

/**
 * Nerd-Font-Glyphen für Loglevels. Material Design Codepoints — funktionieren
 * sobald ein Nerd-Font-Patch (Meslo LGS Nerd Font Mono ist im Repo) ausgeliefert wird,
 * sonst sieht der User ein Tofu. Fallback rendert die Komponente das Kürzel.
 */
export const LEVEL_GLYPH: Record<LogLevel, string> = {
  TRACE: "\u{f0297}", // ti-traffic-cone
  DEBUG: "\u{f0306}", // ti-bug
  INFO: "\u{f02fc}", // ti-info-circle
  WARN: "\u{f0026}", // ti-alert-triangle
  ERROR: "\u{f015a}", // ti-circle-x
  FATAL: "\u{f0e08}", // ti-skull
};

export const LEVEL_TONE: Record<LogLevel, string> = {
  TRACE: "text-muted-foreground",
  DEBUG: "text-muted-foreground",
  INFO: "text-foreground",
  WARN: "text-warning",
  ERROR: "text-destructive",
  FATAL: "text-destructive",
};
